import { BaseContainerModel } from '../../base-container.model';
import { bl_bi_report_query_event_hdr_RowClass } from '../../../dbschema/bl_bi_report_query_event_hdr.model';

export class QueryEventHdrModel extends BaseContainerModel {
  bl_bi_report_query_event_hdr: bl_bi_report_query_event_hdr_RowClass = new bl_bi_report_query_event_hdr_RowClass();
}
